<template>
    <b-card no-body>
        <b-card-body>
            <b-card bg-variant="light">
                <b-form-row @keyup.enter="load">
                    <b-col lg="7" sm="9" class="text-left">
                        <lg-form-input v-model="form.produto" label="Produto" description="" />
                    </b-col>

                    <b-col cols="2" class="text-right">
                        <b-form-checkbox v-model="descricaoExata" id="checkbox-3" class="mt-3 mr-5">
                            <template #default>
                                <p style="font-size: 12px;">Descrição Exata</p>
                            </template>
                        </b-form-checkbox>
                    </b-col>

                    <b-col cols="3" class="text-right">
                        <b-button class="ml-3 mr-1 my-3" size="sm" style="height: 20px" pill variant="primary"
                            @click="load" type="button" id="localizar">
                            <div class="btn-size-alinhamento">
                                <b-icon icon="search" />
                            </div>
                            <b-tooltip target="localizar" title="Localizar"></b-tooltip>
                        </b-button>
                        <b-button class="ml-2 mr-3 my-2" style="height: 20px" size="sm" pill @click="clearForm"
                            id="apagar">
                            <div class="btn-size-alinhamento">
                                <b-icon icon="eraser" />
                            </div>
                            <b-tooltip target="apagar" title="Limpar"></b-tooltip>
                        </b-button>
                    </b-col>
                </b-form-row>
                <b-table responsive class="mt-2" small :busy="this.busy" :items="this.records"
                    :fields="this.tableFields" :hover="true" @row-dblclicked="produtoSelect">
                    <template #table-busy>
                        <div class="text-center text-primary my-2">
                            <b-spinner class="align-middle"></b-spinner>
                        </div>
                    </template>

                    <template v-slot:cell(visualizar)="row">
                        <b-button v-b-tooltip.hover.top="'Fotos do Produto'" class="my-2" size="sm" pill
                            variant="primary" @click="visualizar(row.item)">
                            <b-icon icon="card-image" />
                        </b-button>
                    </template>

                    <template v-slot:cell(action)="{ item }">
                        <lg-button-acoes-icons :actions="actionsBtn" :itemRecord="item"></lg-button-acoes-icons>
                    </template>
                </b-table>
                <b-row style="margin-top: 12px" v-if="records && records.length > 0">
                    <b-col cols="6" style="display: flex; align-items: center; font-size: 12px">
                        <b-col cols="6" style="display: flex; align-items: center; font-size: 12px">Página {{ page }} de
                            {{
                                totalPage }} -
                            {{ total }} registros</b-col>
                        <b-col cols="6" style="display: flex; align-items: center; font-size: 12px">Mostrando:&nbsp;
                            <b-form-select size="sm" v-model="perPage" @change="() => this.load()"
                                :options="perPageOptions">
                            </b-form-select>
                        </b-col>
                    </b-col>
                    <b-col cols="6">
                        <div class="d-flex justify-content-end align-items-end">
                            <b-pagination style="margin-bottom: 10px; margin-top: 10px" v-model="page"
                                :per-page="perPage" :total-rows="total"></b-pagination>
                        </div>
                        <Modal-foto-produto-almoxarifado v-if="showModalFotoProdutoAlmoxarifado" @close="cancelar"
                            :prefix="title" :id="currentProductId" :podeEditar="false" />
                    </b-col>
                </b-row>
            </b-card>
        </b-card-body>
    </b-card>
</template>
<script>
import LgFormInput from "@/core/components/Form/LgFormInput.vue"
import { ListResourceMixin } from "@/core/mixins/resource"
import { FormResourceMixin } from "@/core/mixins/resource"
import ResourceService from "@/core/api/ResourceService"
import ConfirmMixin from "@/core/mixins/confirm"
import ModalFotoProdutoAlmoxarifado from "@/core/components/Modals/ModalFotoProdutoAlmoxarifado.vue"
import LgButtonAcoesIcons from "@/core/components/Form/LgButtonAcoesIcons.vue"
import AlmoxarifadoProdutoService from "@/core/api/AlmoxarifadoProdutoService"
import TipoOperacaoAlmoxarifadoProdutoEnum from "@/core/utils/TipoOperacaoAlmoxarifadoProdutoEnum"
import { getContext } from "@/core/auth"


export default {
    components: {
        LgFormInput,
        ModalFotoProdutoAlmoxarifado,
        LgButtonAcoesIcons,
    },

    props: {
        id: Number,
        almoxarifado: {
            type: Number,
            default: null,
        },
        idFoto: Number,
        title: { type: String, default: "Produtos do Almoxarifado " },
        tipoOperacao: {
            type: TipoOperacaoAlmoxarifadoProdutoEnum,
            default: () => TipoOperacaoAlmoxarifadoProdutoEnum.CONSULTA,
        },
    },

    data() {
        return {
            currentProductId: null,
            perPage: 10,
            perPageOptions: [10, 25, 50, 100],
            filtro: "",
            right: "",
            descricaoExata: false,
            showModalFotoProdutoAlmoxarifado: false,
            form: {
                produto: "",
                numero: "",
                almoxarifado: "",
                situacao: "1",
                invisivel: "1",
            },
        }
    },

    mixins: [ListResourceMixin, FormResourceMixin, ConfirmMixin],

    beforeMount() {
        this.$AlmoxarifadoProdutoService = new AlmoxarifadoProdutoService()
        this.$SaldoAlmoxarifadoProdutoService = new ResourceService(
            "/api/saldo-almoxarifado-produto"
        )

    },

    mounted() {
        this.busy = false
    },

    watch: {
        page() {
            this.load()
        },

        "form.produto"() {
            if (this.form.produto === undefined || this.form.produto === "") {
                this.records = []
            }
        },
    },

    computed: {
        tableFields() {
            return [
                {
                    key: "numero",
                    label: "Número",
                    thStyle: "font-size: 16px;",
                    tdStyle: "font-size: 13px",
                },
                {
                    key: "produto.descricaoResumida",
                    label: "Produto",
                    thStyle: "font-size: 16px;",
                    tdStyle: "font-size: 13px",
                },
                {
                    key: "almoxarifado.descricao",
                    label: "Almoxarifado",
                    thStyle: "font-size: 16px;",
                    tdStyle: "font-size: 13px",
                },
                {
                    key: "visualizar",
                    label: "",
                    thStyle: "font-size: 16px;",
                    tdStyle: "font-size: 13px;text-align:center",
                },
            ]
        },
    },

    methods: {


        async load() {

            if (!this.form.produto || this.form.produto.length < 3) {
                this.$notify({
                    type: "warning",
                    message: "Termo pesquisado deve ter no mínimo 3 caracteres!",
                });

                return;
            }

            this.filtro = {}


            this.filtro.descricaoExata = this.descricaoExata;
            this.filtro.descricao = this.form.produto;

            this.filtro.tipoBem = 2;
            this.filtro.bloqueado = 0;
            this.filtro.almoxarifadoBloqueado = 0;
            this.filtro.situacaoAlmoxarifado = 1;
            this.filtro.departamento = getContext().departamento.id;
            this.filtro.invisivel = 0;

            if (this.tipoOperacao === TipoOperacaoAlmoxarifadoProdutoEnum.DEVOLUCAO) {
                this.filtro.itemPrecisaTerRegistroEntrada = true;
            }


            if (this.almoxarifado != null)
                this.filtro.almoxarifado = this.almoxarifado;

            this.busy = true
            this.$AlmoxarifadoProdutoService
                .findAll({
                    size: this.perPage,
                    page: this.page,
                    params: this.filtro,
                })
                .then(response => {
                    this.records = response.data.content
                    this.total = response.data.totalElements
                    this.totalPage = response.data.totalPages
                })
                .finally(() => {
                    this.busy = false
                })
        },

        clearForm() {
            this.descricaoExata = false
            this.form.numero = ""
            this.form.produto = ""
            this.form.almoxarifado = ""
        },

        visualizar(item) {
            this.currentProductId = item.produto.id
            this.showModalFotoProdutoAlmoxarifado = true
        },

        produtoSelect(almoxarifadoProduto) {
            if (this.tipoOperacao === TipoOperacaoAlmoxarifadoProdutoEnum.PEDIDO) {
                this.$SaldoAlmoxarifadoProdutoService
                    .findById(almoxarifadoProduto.id)
                    .then(response => {
                        const saldo = Array.isArray(response.data)
                            ? response.data[0].saldo
                            : response.data.saldo

                        if (saldo === 0) {
                            this.$notify({
                                title: "Atenção",
                                message: "Produto sem saldo disponível",
                                type: "warning",
                            })
                        } else {
                            this.$emit("onselect", almoxarifadoProduto)
                            this.cancelar()
                        }
                    })
            } else {
                this.$emit("onselect", almoxarifadoProduto)
                this.cancelar()
            }
        },

        cancelar() {
            this.showModalFotoProdutoAlmoxarifado = false
        },
    },
}
</script>
